import {SortableTableHeaderComponent, SortDirection} from './sortable-table-header.component';

export function applySortingToHeaders(
    headers: readonly SortableTableHeaderComponent[],
    sorting: {column: string; direction: SortDirection | null},
): void {
    headers.forEach(header => {
        header.direction = header.column === sorting.column ? sorting.direction : null;
    });
}
